import { render, staticRenderFns } from "./PCPushCard.vue?vue&type=template&id=0dd53e9b&"
import script from "./PCPushCard.vue?vue&type=script&lang=js&"
export * from "./PCPushCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports